var styles = {"draggableContent":"styles_draggable-content__EzCzm","drag":"styles_drag__JoqV8","dragContainer":"styles_drag-container__9vtM2","icon":"styles_icon__LF3kj"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
